<div class="admissions-manager-trimester-switchover-view-part" [style.height.px]="height()">

	<div class="details">

		<ul class="message-list">
			@for (msg of messages(); track msg) {
			<li [ngClass]="'msg-' + msg.type.toLowerCase()">
				<div class="icon-wrapper" [title]="msg.type">
					<i class="fa-solid" [ngClass]="getIconClass(msg.type)"></i>
				</div>
				<span class="message-text">
					{{ msg.message }}
				</span>
			</li>
			}
		</ul>

		@if(funcData()) {
		<pre style="background:aliceblue;max-width:750px">
			<ngx-json-viewer [json]="funcData()" [expanded]="false"></ngx-json-viewer>
		</pre>
		}
	</div>

	<div class="actions-bar">
		<button class="btn" (click)="load()">{{ loadLabel() }}</button>
		@if(showRunButtons()){ <button class="btn" (click)="run('Test')">Test Run</button> }
		@if(showRunButtons()){ <button class="btn" (click)="run('Live')">Live Run</button> }
	</div>
</div>